import React from "react";
import { FieldProps } from "formik";
import { Text } from "rebass";

import { Mode } from "../../../store/modules/library/selectors";

interface IProps extends FieldProps {
  mode: Mode;
}

const disableModes = [Mode.new, Mode.view];

export const TitleInput: React.FC<IProps> = ({ field, form: { isSubmitting }, mode }) => (
  <Text
    as="input"
    type="text"
    width="100%"
    p="0"
    fontFamily="unset"
    fontSize="32px"
    fontWeight="bold"
    placeholder="Title"
    color={disableModes.includes(mode) ? "#333" : "#000"}
    bg="transparent"
    css="display: block; overflow: hidden; text-overflow: ellipsis; transition: .4s color;"
    disabled={disableModes.includes(mode) || isSubmitting}
    {...field}
  />
);
